import { FormControl, InputLabel, Select, MenuItem, Box } from '@mui/material';

export default function PartnerSelector({ partners, value, onChange, label = 'Partner', sx }) {
  return (
    <Box sx={{ minWidth: 240, ...sx }}>
      <FormControl fullWidth size="small">
        <InputLabel>{label}</InputLabel>
        <Select label={label} value={value || ''} onChange={e => onChange(e.target.value)}>
          {partners.map(p => (
            <MenuItem key={p.id} value={p.id}>
              {p.companyName}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
}
